var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortIconDeactivate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.938,
    height: 18,
    viewBox: "0 0 12.938 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-sort",
    "data-name": "Icon awesome-sort",
    d: "M2.279,14.451H13.04a1.087,1.087,0,0,1,.769,1.854L8.428,21.686a1.081,1.081,0,0,1-1.533,0L1.51,16.3A1.087,1.087,0,0,1,2.279,14.451ZM13.809,9.7,8.428,4.323a1.081,1.081,0,0,0-1.533,0L1.51,9.7a1.087,1.087,0,0,0,.769,1.854H13.04A1.087,1.087,0,0,0,13.809,9.7Z",
    transform: "translate(-1.19 -4.004)",
    fill: "#E0E0E1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIconDeactivate);
export default __webpack_public_path__ + "static/media/sort-icon-deactivate.a205181fb12c6de72937384ededb0edc.svg";
export { ForwardRef as ReactComponent };